// Day 21 — the ONLY email an auto-renewing policy gets. No pricing, no SMS.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { collectionFor, genericEmailHtml } from "../../layouts/generic";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Your ${brand.name} policy will renew automatically on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  genericEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    ...collectionFor(data.paymentType),
    bodyHtml: body(
      p(
        `Good news — there's nothing you need to do. Your policy for ${b(`'${esc(data.companyName)}'`)} will ${b(`automatically renew on ${longDate(data.renewalDate)}`)}, so your cover will continue without interruption.`,
      ),
      p(
        `We'll collect your renewal payment as set out below, and your renewal documents will be available in your ${b("My Portal")} account once your policy renews.`,
      ),
      p(
        `You only need to get in touch if you do ${b("not")} want to renew — in that case, please call our UK-based team on ${call(brand)} and we'll take care of it.`,
      ),
    ),
  });
